import { render, staticRenderFns } from "./HeaderDeParcelas.vue?vue&type=template&id=f65d451e&scoped=true"
import script from "./HeaderDeParcelas.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderDeParcelas.vue?vue&type=script&setup=true&lang=js"
import style0 from "./HeaderDeParcelas.vue?vue&type=style&index=0&id=f65d451e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65d451e",
  null
  
)

export default component.exports